import './UserImpersonationWrapper.scss'

import React from 'react'
import PropTypes from 'prop-types'

export const UserImpersonationWrapper = ({userInfo, localize}) => {
  const {isImpersonation, firstName, lastName} = userInfo
  if (!isImpersonation) {
    return null
  }

  const impersonatedUserName = `${firstName} ${lastName}`
  return (
    <div className='impersonation-banner'>
        <span className='impersonation-banner-message'>
            { localize('globalHeader.Label_UserImpersonationBanner') } <span className='impersonation-banner-impersonator'>{ impersonatedUserName }</span>
        </span>
    </div>
  )
}

UserImpersonationWrapper.defaultProps = {
  userInfo: {},
  localize: s => s,
}

UserImpersonationWrapper.propTypes = {
  userInfo: PropTypes.object,
  localize: PropTypes.func,
}

export default UserImpersonationWrapper



// WEBPACK FOOTER //
// ./src/components/Header/UserImpersonationWrapper.js